import { render, staticRenderFns } from "./MonitoringProductionDashboard.vue?vue&type=template&id=38002511&"
import script from "./MonitoringProductionDashboard.vue?vue&type=script&lang=js&"
export * from "./MonitoringProductionDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports